export const FIELD_TYPE_LABELS: Record<Attr_['attr_type'], string> = {
  text: 'Text',
  number: 'Number',
  datetime: 'Date',
  url: 'Website',
  multiple_choice: 'Multiple choice',
  free_text: 'Free text',
  boolean: 'Boolean'
};
